const Header = () => {
    return (
        <section>
            <div className="text-center">
                <img alt='FinSys' src="/static/frontlogo.png" />
                <h1>FinSys</h1>
            </div>
        </section>
    );
};

export default Header;